import { z } from 'zod'
import { StsDocument } from '~/shared/api'
import { buildI18nMessage } from '~/shared/lib/i18nMessageHelper'
import {
  stsDocumentNumberSchema,
  stsDocumentSeriesSchema,
} from '~/shared/lib/schemas'

const baseSchema = StsDocument.schema.pick({
  issuedDate: true,
  expirationDate: true,
  issuedBy: true,
})

export const formSchema = baseSchema.and(
  z.object({
    number: stsDocumentNumberSchema,
    series: stsDocumentSeriesSchema,
    plateNumber: z
      .string({ description: buildI18nMessage('form.license plate number') })
      .regex(
        /^[АВЕКМНОРСТУХ]\d{3}[АВЕКМНОРСТУХ]{2}(\d{2,3})$|^[АВЕКМНОРСТУХ]{2}(\d{5})$/iu,
        buildI18nMessage(
          "validate.license plate has invalid format, e.g. 'А111АА777' or 'ХА11111'",
        ),
      ),
  }),
)

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = TypeFormSchema
